var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getProp, str2buff, buff2str, isAndroid } from '../utils';
export const getIsUvpaa = () => __awaiter(void 0, void 0, void 0, function* () {
    let res = false;
    try {
        res = yield window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
    }
    catch (e) {
        return false;
    }
    return res;
});
export const getIsCMA = () => __awaiter(void 0, void 0, void 0, function* () {
    let res = false;
    try {
        if (window.PublicKeyCredential && window.PublicKeyCredential.isConditionalMediationAvailable) {
            res = yield window.PublicKeyCredential.isConditionalMediationAvailable();
        }
    }
    catch (e) {
        return false;
    }
    return !!res;
});
export const parsePublicKeyCredential = (credentialResponse) => {
    const publicKeyCredential = {};
    if ('id' in credentialResponse) {
        publicKeyCredential.id = credentialResponse.id;
    }
    if ('type' in credentialResponse) {
        publicKeyCredential.type = credentialResponse.type;
    }
    if ('rawId' in credentialResponse) {
        publicKeyCredential.rawId = buff2str(credentialResponse.rawId);
    }
    if ('response' in credentialResponse) {
        const response = {};
        response.clientDataJSON = buff2str(credentialResponse.response.clientDataJSON);
        response.attestationObject = buff2str(credentialResponse.response.attestationObject);
        publicKeyCredential.response = response;
    }
    return publicKeyCredential;
};
export const createPublicKeyCredential = ({ passkeyChallenge = {}, publicCredential = '', env }) => __awaiter(void 0, void 0, void 0, function* () {
    const getCreateChallengeRes = getProp(passkeyChallenge, 'data.webAuthN.getCreateChallenge', {});
    // If running proxy app on local and pointing to the graphql server build on stage, which will lead to the mismatch relying id
    // So hardcode the rpId on local
    // And value of env will be as development, stage, sandBox or prod
    const rpId = env === 'development' ? 'localhost.paypal.com' : getCreateChallengeRes.rp.id;
    const isAndroidDevice = isAndroid();
    try {
        const publicKeyCredentialCreationOptions = {
            rp: {
                id: rpId,
                name: getCreateChallengeRes.rp.name,
            },
            user: {
                id: str2buff(getCreateChallengeRes.user.id),
                name: publicCredential || '',
                displayName: publicCredential || '',
            },
            challenge: str2buff(getCreateChallengeRes.challenge),
            pubKeyCredParams: getCreateChallengeRes.pubKeyCredParams,
            authenticatorSelection: {
                authenticatorAttachment: 'platform',
                userVerification: 'preferred',
                requireResidentKey: true, // required for both ios and android
            },
            attestation: 'direct',
        };
        if (isAndroidDevice) {
            publicKeyCredentialCreationOptions.authenticatorSelection.residentKey = 'preferred';
        }
        const createPassKeyCredential = yield navigator.credentials.create({
            publicKey: publicKeyCredentialCreationOptions,
        });
        const publicKeyObj = parsePublicKeyCredential(createPassKeyCredential);
        return publicKeyObj;
    }
    catch (err) {
        return {
            error: 'publicKeyCreateFailed',
            name: err.name || 'Unknown',
            message: err.message || 'Unknown',
        };
    }
});
